import useCredentialsAdapter from 'new/state/credentials/adapter/useCredentialsAdapter';
import { useEffect, useRef, useState } from 'react';

type Data = {
  id: number;
  owner_id: number;
  org_id: number;
  connector_type: string;
  users_api_key_id: number | null;
  name: string;
  description: string;
  vendor_id: number;
  auth_template_id: number;
  verified_status: string;
  verified_at: string | null;
  copied_from_id: number | null;
  created_at: string;
  updated_at: string;
  data_sources: any[];
  data_sinks: any[];
  quarantine_settings: any[];
};

type Response = {
  data: Data;
  loading: boolean;
  error: any;
};

const initialResponse: Response = {
  data: null,
  loading: false,
  error: null,
};

export function useCredentialUsage(credentialId: number): Response {
  const fetched = useRef(false);
  const [response, setResponse] = useState<Response>(initialResponse);
  const { getCredentialUsage } = useCredentialsAdapter();

  useEffect(() => {
    if (!fetched.current) {
      setResponse({ data: null, loading: true, error: null });
      getCredentialUsage(credentialId)
        .then((res) => setResponse({ data: res.result, loading: false, error: null }))
        .catch((error) => setResponse({ data: null, loading: false, error }))
        .finally(() => (fetched.current = true));
    }
  }, [credentialId]);

  return response;
}
